<template>
<section class="vpn-section privacy-choice">
  <div class="vpn-section__inner">
    <h3 class="vpn-section__title">{{ choiceTitle }}</h3>
    <p>{{ choiceP1 }}</p>
    <p>{{ choiceP2 }}</p>
    <p>{{ choiceP3 }}</p>
  </div>
</section>
</template>

<script>
import homeLocaleContent from '@/mixins/homeLocaleContent';

export default {
  name: 'PrivacyChoiceSection',
  mixins: [homeLocaleContent],
  computed: {
    choiceTitle() {
      return this.homeLocale?.privacyChoiceTitle || 'Which Privacy Solution Fits Your Needs?';
    },
    choiceP1() {
      return (
        this.homeLocale?.privacyChoiceP1 ||
        'Choose Secure VPN App if you need stronger privacy, stable connections, and protection for all your online activities, including browsing, streaming, and using apps on your device.'
      );
    },
    choiceP2() {
      return (
        this.homeLocale?.privacyChoiceP2 ||
        'Choose a Free Web Proxy Online if you only need a quick browser-based solution for occasional access without installing additional software.'
      );
    },
    choiceP3() {
      return (
        this.homeLocale?.privacyChoiceP3 ||
        'For regular internet use, a Secure VPN App offers a more complete and reliable way to stay private and secure online.'
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/vpn-sections.scss';

.privacy-choice {
  // 顶部只留小间距，贴着上方表格
  padding-top: 8px;

  .vpn-section__title {
    text-align: left;
    margin-bottom: 12px;
    // H3 应有的字号与字重（小于上方 H2）
    font-size: clamp(20px, 2.4vw, 24px);
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1.3;
  }

  p {
    margin: 0 0 12px;
    max-width: none;
    text-align: left;
    color: var(--vpn-ink-muted, #5b6475);
    font-size: 15px;
    line-height: 1.6;

    &:last-child {
      margin-bottom: 0;
    }

    strong {
      color: var(--vpn-ink, #1f2430);
    }
  }
}

@media (max-width: 768px) {
  .privacy-choice {
    padding-top: 4px;

    .vpn-section__title {
      font-size: clamp(18px, 5vw, 22px);
      margin-bottom: 10px;
    }

    p {
      font-size: 14px;
    }
  }
}
</style>
